var restOf = {
	BG: 'Rest of Europe',
	AI: 'Rest of Americas',
	BD: 'Rest of Asia Pacific',
	BH: 'Rest of Middle East',
	DZ: 'Rest of Africa',
};

var euCountryCodes = [
	'AT', // Austria
	'BE', // Belgium
	'BG', // Bulgaria
	'HR', // Croatia
	'CY', // Cyprus
	'CZ', // Czech Republic
	'DK', // Denmark
	'EE', // Estonia
	'FI', // Finland
	'FR', // France
	'DE', // Germany
	'GR', // Greece
	'HU', // Hungary
	'IE', // Ireland
	'IT', // Italy
	'LV', // Latvia
	'LT', // Lithuania
	'LU', // Luxembourg
	'MT', // Malta
	'NL', // Netherlands
	'PL', // Poland
	'PT', // Portugal
	'RO', // Romania
	'SK', // Slovakia
	'SI', // Slovenia
	'ES', // Spain
	'SE', // Sweden
];

var countryCodeToCountry = {
	BD: 'Bangladesh',
	BE: 'Belgium',
	BF: 'Burkina Faso',
	BG: 'Bulgaria',
	BA: 'Bosnia and Herzegovina',
	BB: 'Barbados',
	WF: 'Wallis and Futuna',
	BL: 'Saint Barthelemy',
	BM: 'Bermuda',
	BN: 'Brunei',
	BO: 'Bolivia',
	BH: 'Bahrain',
	BI: 'Burundi',
	BJ: 'Benin',
	BT: 'Bhutan',
	JM: 'Jamaica',
	BV: 'Bouvet Island',
	BW: 'Botswana',
	WS: 'Samoa',
	BQ: 'Bonaire, Saint Eustatius and Saba ',
	BR: 'Brazil',
	BS: 'Bahamas',
	JE: 'Jersey',
	BY: 'Belarus',
	BZ: 'Belize',
	RU: 'Russia',
	RW: 'Rwanda',
	RS: 'Serbia',
	TL: 'East Timor',
	RE: 'Reunion',
	TM: 'Turkmenistan',
	TJ: 'Tajikistan',
	RO: 'Romania',
	TK: 'Tokelau',
	GW: 'Guinea-Bissau',
	GU: 'Guam',
	GT: 'Guatemala',
	GS: 'South Georgia and the South Sandwich Islands',
	GR: 'Greece',
	GQ: 'Equatorial Guinea',
	GP: 'Guadeloupe',
	JP: 'Japan',
	GY: 'Guyana',
	GG: 'Guernsey',
	GF: 'French Guiana',
	GE: 'Georgia',
	GD: 'Grenada',
	GB: 'United Kingdom',
	GA: 'Gabon',
	SV: 'El Salvador',
	GN: 'Guinea',
	GM: 'Gambia',
	GL: 'Greenland',
	GI: 'Gibraltar',
	GH: 'Ghana',
	OM: 'Oman',
	TN: 'Tunisia',
	JO: 'Jordan',
	HR: 'Croatia',
	HT: 'Haiti',
	HU: 'Hungary',
	HK: 'Hong Kong',
	HN: 'Honduras',
	HM: 'Heard Island and McDonald Islands',
	VE: 'Venezuela',
	PR: 'Puerto Rico',
	PS: 'Palestinian Territory',
	PW: 'Palau',
	PT: 'Portugal',
	SJ: 'Svalbard and Jan Mayen',
	PY: 'Paraguay',
	IQ: 'Iraq',
	PA: 'Panama',
	PF: 'French Polynesia',
	PG: 'Papua New Guinea',
	PE: 'Peru',
	PK: 'Pakistan',
	PH: 'Philippines',
	PN: 'Pitcairn',
	PL: 'Poland',
	PM: 'Saint Pierre and Miquelon',
	ZM: 'Zambia',
	EH: 'Western Sahara',
	EE: 'Estonia',
	EG: 'Egypt',
	ZA: 'South Africa',
	EC: 'Ecuador',
	IT: 'Italy',
	VN: 'Vietnam',
	SB: 'Solomon Islands',
	ET: 'Ethiopia',
	SO: 'Somalia',
	ZW: 'Zimbabwe',
	SA: 'Saudi Arabia',
	ES: 'Spain',
	ER: 'Eritrea',
	ME: 'Montenegro',
	MD: 'Moldova',
	MG: 'Madagascar',
	MF: 'Saint Martin',
	MA: 'Morocco',
	MC: 'Monaco',
	UZ: 'Uzbekistan',
	MM: 'Myanmar',
	ML: 'Mali',
	MO: 'Macao',
	MN: 'Mongolia',
	MH: 'Marshall Islands',
	MK: 'Macedonia',
	MU: 'Mauritius',
	MT: 'Malta',
	MW: 'Malawi',
	MV: 'Maldives',
	MQ: 'Martinique',
	MP: 'Northern Mariana Islands',
	MS: 'Montserrat',
	MR: 'Mauritania',
	IM: 'Isle of Man',
	UG: 'Uganda',
	TZ: 'Tanzania',
	MY: 'Malaysia',
	MX: 'Mexico',
	IL: 'Israel',
	FR: 'France',
	IO: 'British Indian Ocean Territory',
	SH: 'Saint Helena',
	FI: 'Finland',
	FJ: 'Fiji',
	FK: 'Falkland Islands',
	FM: 'Micronesia',
	FO: 'Faroe Islands',
	NI: 'Nicaragua',
	NL: 'Netherlands',
	NO: 'Norway',
	NA: 'Namibia',
	VU: 'Vanuatu',
	NC: 'New Caledonia',
	NE: 'Niger',
	NF: 'Norfolk Island',
	NG: 'Nigeria',
	NZ: 'New Zealand',
	NP: 'Nepal',
	NR: 'Nauru',
	NU: 'Niue',
	CK: 'Cook Islands',
	XK: 'Kosovo',
	CI: 'Ivory Coast',
	CH: 'Switzerland',
	CO: 'Colombia',
	CN: 'China',
	CM: 'Cameroon',
	CL: 'Chile',
	CC: 'Cocos Islands',
	CA: 'Canada',
	CG: 'Republic of the Congo',
	CF: 'Central African Republic',
	CD: 'Democratic Republic of the Congo',
	CZ: 'Czech Republic',
	CY: 'Cyprus',
	CX: 'Christmas Island',
	CR: 'Costa Rica',
	CW: 'Curacao',
	CV: 'Cape Verde',
	CU: 'Cuba',
	SZ: 'Swaziland',
	SY: 'Syria',
	SX: 'Sint Maarten',
	KG: 'Kyrgyzstan',
	KE: 'Kenya',
	SS: 'South Sudan',
	SR: 'Suriname',
	KI: 'Kiribati',
	KH: 'Cambodia',
	KN: 'Saint Kitts and Nevis',
	KM: 'Comoros',
	ST: 'Sao Tome and Principe',
	SK: 'Slovakia',
	KR: 'South Korea',
	SI: 'Slovenia',
	KP: 'North Korea',
	KW: 'Kuwait',
	SN: 'Senegal',
	SM: 'San Marino',
	SL: 'Sierra Leone',
	SC: 'Seychelles',
	KZ: 'Kazakhstan',
	KY: 'Cayman Islands',
	SG: 'Singapore',
	SE: 'Sweden',
	SD: 'Sudan',
	DO: 'Dominican Republic',
	DM: 'Dominica',
	DJ: 'Djibouti',
	DK: 'Denmark',
	VG: 'British Virgin Islands',
	DE: 'Germany',
	YE: 'Yemen',
	DZ: 'Algeria',
	US: 'United States',
	UY: 'Uruguay',
	YT: 'Mayotte',
	UM: 'United States Minor Outlying Islands',
	LB: 'Lebanon',
	LC: 'Saint Lucia',
	LA: 'Laos',
	TV: 'Tuvalu',
	TW: 'Taiwan',
	TT: 'Trinidad and Tobago',
	TR: 'Turkey',
	LK: 'Sri Lanka',
	LI: 'Liechtenstein',
	LV: 'Latvia',
	TO: 'Tonga',
	LT: 'Lithuania',
	LU: 'Luxembourg',
	LR: 'Liberia',
	LS: 'Lesotho',
	TH: 'Thailand',
	TF: 'French Southern Territories',
	TG: 'Togo',
	TD: 'Chad',
	TC: 'Turks and Caicos Islands',
	LY: 'Libya',
	VA: 'Vatican',
	VC: 'Saint Vincent and the Grenadines',
	AE: 'United Arab Emirates',
	AD: 'Andorra',
	AG: 'Antigua and Barbuda',
	AF: 'Afghanistan',
	AI: 'Anguilla',
	VI: 'U.S. Virgin Islands',
	IS: 'Iceland',
	IR: 'Iran',
	AM: 'Armenia',
	AL: 'Albania',
	AO: 'Angola',
	AQ: 'Antarctica',
	AS: 'American Samoa',
	AR: 'Argentina',
	AU: 'Australia',
	AT: 'Austria',
	AW: 'Aruba',
	IN: 'India',
	AX: 'Aland Islands',
	AZ: 'Azerbaijan',
	IE: 'Ireland',
	ID: 'Indonesia',
	UA: 'Ukraine',
	QA: 'Qatar',
	MZ: 'Mozambique',
};

var otherCountriesOf = {
	'Europe': [
		'AL',
		'AD',
		'AM',
		'BY',
		'BA',
		'BG',
		'HR',
		'CZ',
		'FO',
		'GE',
		'GI',
		'GL',
		'GG',
		'HU',
		'IS',
		'IM',
		'JE',
		'XK',
		'LI',
		'MK',
		'YT',
		'MD',
		'MC',
		'ME',
		'PL',
		'RE',
		'RO',
		'SI',
		'SK',
		'SM',
		'RS',
		'SJ',
		'UA',
		'VA',
		'GP',
		'AX',
	],
	'Americas': [
		'AI',
		'AG',
		'AW',
		'BS',
		'BB',
		'BZ',
		'BM',
		'BO',
		'VG',
		'AN',
		'KY',
		'CO',
		'CR',
		'CW',
		'DM',
		'DO',
		'EC',
		'SV',
		'FK',
		'PF',
		'GD',
		'GT',
		'GY',
		'HT',
		'HN',
		'JM',
		'MQ',
		'MS',
		'NI',
		'PA',
		'PY',
		'PE',
		'MF',
		'BL',
		'KN',
		'LC',
		'PM',
		'VC',
		'SR',
		'TT',
		'TC',
		'UM',
		'UY',
		'VE',
	],
	'Asia Pacific': [
		'AF',
		'AZ',
		'BD',
		'BT',
		'IO',
		'BN',
		'KH',
		'CX',
		'CC',
		'CK',
		'FJ',
		'PF',
		'FQ',
		'KZ',
		'KI',
		'KG',
		'LA',
		'MO',
		'MV',
		'MN',
		'MM',
		'NR',
		'NP',
		'NC',
		'NU',
		'NF',
		'PK',
		'PG',
		'PN',
		'RU',
		'WS',
		'SB',
		'GS',
		'LK',
		'TJ',
		'TL',
		'TK',
		'TO',
		'TM',
		'TV',
		'UZ',
		'VU',
		'VN',
		'WF',
	],
	'Middle East': ['BH', 'EG', 'IQ', 'JO', 'OM', 'PS', 'YE'],
	'Africa': [
		'DZ',
		'AO',
		'SH',
		'BJ',
		'BW',
		'BF',
		'BI',
		'CM',
		'CV',
		'CF',
		'TD',
		'KM',
		'CD',
		'CG',
		'CI',
		'DJ',
		'GQ',
		'ER',
		'SZ',
		'ET',
		'GA',
		'GM',
		'GH',
		'GN',
		'GW',
		'KE',
		'LS',
		'LR',
		'LY',
		'MG',
		'MW',
		'ML',
		'MR',
		'MU',
		'MA',
		'MZ',
		'NA',
		'NE',
		'NG',
		'RW',
		'ST',
		'SN',
		'SC',
		'SL',
		'SO',
		'SS',
		'SH',
		'SD',
		'TZ',
		'TG',
		'TN',
		'UG',
		'EH',
		'ZM',
		'ZW',
	],
};

var theme = window.theme || {};

async function localLocate() {
	const req = await fetch(
		window.Shopify.routes.root +
			'browsing_context_suggestions.json' +
			'?country[enabled]=true' +
			`&country[exclude]=${window.Shopify.country}` +
			'&language[enabled]=true' +
			`&language[exclude]=${window.Shopify.language}`
	);
	const res = await req.json();
	return res;
}

function toggleCountryPop() {
	const popup = document.querySelector('.js-country-switch-popup');
	const popOverlay = document.querySelector('.js-country-switch-popup .js-close-overlay');
	if (popup) {
		popup.classList.toggle('hidden');
		popOverlay.classList.toggle('hidden');
		popup.classList.toggle('flex');
	} else {
		console.error('Popup element not found');
	}
}

// display the country selector popup when needed
var hasCheckedCountryCookie = 'checked-country';

if (document.cookie.indexOf(hasCheckedCountryCookie) == -1) {
	localLocate().then((res) => {
		if (!('handle' in res.detected_values.country)) {
			console.log('country identification error 1');
			return;
		}
		var countryCode = res.detected_values.country.handle;

		if (!(theme.countryCode in countryCodeToCountry)) {
			console.log('Unknown country in theme', theme.countryCode);
		}
		if (!(countryCode in countryCodeToCountry)) {
			console.log('Unknown country', countryCode);
		}

		var showPopup = false;
		for (var i in otherCountriesOf) {
			var otherCountries = otherCountriesOf[i];
			if (otherCountries.indexOf(countryCode) != -1) {
				showPopup = otherCountries.indexOf(theme.countryCode) == -1;
				break;
			}
		}
		if (!showPopup) {
			if (countryCode != theme.countryCode) showPopup = true;
		}

		if (showPopup) {
			document.querySelector('.js-country-switch-new-country').textContent = countryCodeToCountry[countryCode];
			document.getElementById('form_country_code').value = countryCode;
			toggleCountryPop();
			setLangOptions(countryCode);
		} else {
			setCountryCookie(true);
		}
	});
}

document.querySelectorAll('.js-open-country-selector').forEach((element) => {
	element.addEventListener('click', (e) => {
		e.stopPropagation();
		toggleCountryPop();
		let langSelect = document.getElementById('form_language_code');
		let countrySelect = document.getElementById('form_country_code');

		const langCookie = document.cookie.split('; ').find((row) => row.startsWith(`${hasSelectedLang}=`));
		if (langCookie) {
			const selectedLang = langCookie.split('=')[1];
			langSelect.value = selectedLang;
		}

		setLangOptions(countrySelect.value);
	});
});

let hasSelectedLang = 'selected-lang';

function setLangOptions(cc) {
	let countryCode = cc;
	let langSelect = document.getElementById('form_language_code');
	let langOptions = langSelect.querySelectorAll('option');
	if (countryCode == 'FR') {
		langOptions.forEach((option) => {
			if (option.value == 'fr' || option.value == 'en') {
				option.classList.remove('hidden');
			} else {
				option.classList.add('hidden');
			}
		});
		langSelect.classList.remove('hidden');
	} else if (countryCode == 'DE') {
		langOptions.forEach((option) => {
			if (option.value == 'de' || option.value == 'en') {
				option.classList.remove('hidden');
			} else {
				option.classList.add('hidden');
			}
		});
		langSelect.classList.remove('hidden');
	} else {
		langOptions.forEach((option) => {
			if (option.value != 'en') {
				option.classList.add('hidden');
			}
		});
		langSelect.classList.add('hidden');
	}
}

function setCountryCookie(sessionOnly) {
	var cookieStr = hasCheckedCountryCookie + '=1;';
	if (!sessionOnly) {
		var now = new Date();
		var time = now.getTime();
		var expireTime = time + 2628000000; // 1 month
		now.setTime(expireTime);
		cookieStr += 'expires=' + now.toUTCString(); // set country as checked
	}
	document.cookie = cookieStr;
}

function closeCountrySwitchPopup(askAgain) {
	// document.getElementById('country-switch-popup').style.display = 'none';
	setCountryCookie(askAgain);
	toggleCountryPop();
}

document.querySelectorAll('.js-country-link-btn').forEach((element) => {
	element.addEventListener('click', (e) => {
		e.preventDefault();
		//keep selected filters active when switching langs
		if (typeof search !== 'undefined') {
			search.renderState[indexName].clearRefinements.refine();
		}

		var languageCode = document.getElementById('form_language_code').value;

		var currentUrl = window.location.href;
		var newUrl = currentUrl.replace(/(\.com)(\/|$)/, `$1/${languageCode}/`);
		window.location.href = newUrl;

		var cookieStr = hasSelectedLang + '=' + languageCode + ';';
		document.cookie = cookieStr;

		// var countryCode = element.getAttribute('country');
		// document.getElementById('form_country_code').value = countryCode;

		document.getElementById('localization_form').submit();

		setCountryCookie(true);
	});
});

document.querySelectorAll('.js-close-country-switch-popup').forEach((element) => {
	element.addEventListener('click', (e) => {
		e.stopPropagation();
		closeCountrySwitchPopup(true);
	});
});

document.querySelectorAll('.js-close-country-switch-popup-and-stop-asking').forEach((element) => {
	element.addEventListener('click', (e) => {
		e.stopPropagation();
		closeCountrySwitchPopup(false);
	});
});

document.getElementById('form_country_code').addEventListener('change', (e) => {
	setLangOptions(e.target.value);
	document.getElementById('form_language_code').selectedIndex = 0;
});
